import React from 'react';

const Logo = () => (
    <img src="https://res.cloudinary.com/daveh/image/upload/assets/well-beyond-logo-182x39.png" alt="WellBeyond Logo" />
);

export default Logo;
